export type ViewerFullscreenOutcome = 'native' | 'fallback';

interface ViewerFullscreenDocument {
  fullscreenEnabled?: boolean;
}

export async function requestViewerFullscreen(
  shell: HTMLElement,
  fullscreenDocument: ViewerFullscreenDocument,
): Promise<ViewerFullscreenOutcome> {
  if (
    fullscreenDocument.fullscreenEnabled === false ||
    typeof shell.requestFullscreen !== 'function'
  ) {
    return 'fallback';
  }

  try {
    await shell.requestFullscreen();
    return 'native';
  } catch {
    return 'fallback';
  }
}
